import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { normalizeUser } from '@/lib/adapters/user.adapter'
import { request } from '@/lib/services'
import type { UserType } from '@/lib/types/user.types'

export const useUserStore = defineStore('user', () => {
  const user = ref<UserType>()
  const isLoading = ref(false)
  const error = ref<Error | null>(null)

  const initialize = async () => {
    isLoading.value = true
    error.value = null
    try {
      const response = await request.get('/user/info')
      user.value = normalizeUser(response.data)
    } catch (err) {
      error.value = err as Error
    } finally {
      isLoading.value = false
    }
  }

  const name = computed(() => (user.value ? `${user.value.firstName} ${user.value.lastName}` : ''))
  const id = computed(() => user.value?.id)
  const subscriberId = computed(() => user.value?.subscriber.id || '')

  // Since the whole app is waiting till the user is loaded,
  // we can safely expect that the user always exists
  return {
    id: id as unknown as number,
    user: user as unknown as UserType,
    name: name as unknown as string,
    subscriberId: subscriberId as unknown as string,
    isLoading,
    error,
    initialize,
  }
})
